import type { CheckboxProps } from 'react-aria-components/Checkbox';

import { CheckboxField } from '../checkbox_field/checkbox_field';

import styles from './card_selection_checkbox.module.css';

export type CardSelectionCheckboxProps = Omit<
  CheckboxProps,
  'slot' | 'children' | 'className'
>;

/** Card selection checkbox */
export function CardSelectionCheckbox(props: CardSelectionCheckboxProps) {
  return (
    <CheckboxField {...props} slot="selection" className={styles.checkbox} />
  );
}
